// Resource definition for React Admin
export const feeTemplatesResource = {
  name: 'Fee Templates',
  fields: {
    id: 'ID',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    currency: 'Currency',
    components: 'Components',
    usage: 'Usage',
    active: 'Active',
    isActive: 'Active',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    systemTemplate: 'System Template',
    customTemplate: 'Custom Template',
    feeSchedule: 'fee schedule',
    feeSchedules: 'fee schedules',
    version: 'Version',
    usageCount: 'Schedules Using',
    feeStructure: 'Fee Structure',
  },
};

// Custom fee templates translations (used in custom components)
export const feeTemplates = {
  name: 'Fee Templates',
  fields: {
    id: 'ID',
    name: 'Name',
    description: 'Description',
    currency: 'Currency',
    version: 'Version',
    isActive: 'Active',
    active: 'Active',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    usage: 'Usage',
    usageCount: 'Schedules Using',
    feeSchedule: 'fee schedule',
    feeSchedules: 'fee schedules',
    amount: 'Amount',
    rate: 'Rate',
    rateName: 'Rate Name',
    rateAmount: 'Rate Amount',
    unit: 'Unit',
    timeWindows: 'Time Windows',
    allTimes: 'All Times',
    freeMinutes: 'Free Minutes',
    graceMinutes: 'Grace Period (minutes)',
    maxPerSession: 'Maximum per Session',
    maxPerSessionHelper: 'Optional maximum fee per session',

    type: 'Type',
    components: 'Components',
    systemTemplate: 'System Template',
    customTemplate: 'Custom Template',
    date: 'Date',
    rateMultiplier: 'Rate Multiplier',
    effectiveDate: 'Effective Date',
    createdBy: 'Created By',
    status: 'Status',
    reason: 'Reason',
    oneOffAmount: 'One-off Amount',
    ratePerMinute: 'Rate per Minute',
    pricePerKwh: 'Price per kWh',
    timeUnit: 'Time Unit',
    perMinute: 'Per Minute',
    perHour: 'Per Hour',
    ratePerUnit: 'Rate per Unit',
    maxChargeMinutes: 'Max Charging Time (minutes)',
    noLimitPreAuthAmount: 'Pre-auth Hold Amount',
  },
  components: {
    sessionFee: 'Session Fee',
    energyFee: 'Energy Fee',
    timeFee: 'Time Fee',
    idleFee: 'Idle Fee',
    reservationFee: 'Reservation Fee',
    enabled: 'Enabled',
    disabled: 'Disabled',
    enable: 'Enable',
    energyRates: 'Energy Rates',
    specialDates: 'Special Dates',
    noRates: 'No rates configured',
    energyTimeExclusiveHelp: 'Energy and Time fees are mutually exclusive (both meter consumption).',
    timeRates: 'Time Rates',
  },
  rateTypes: {
    peak: 'Peak',
    'off-peak': 'Off-Peak',
    'mid-peak': 'Mid-Peak',
    'super-off-peak': 'Super Off-Peak',
    standard: 'Standard',
    weekend: 'Weekend',
    weekday: 'Weekday',
    overnight: 'Overnight',
    daytime: 'Daytime',
    evening: 'Evening',
  },
  create: {
    title: 'Create Fee Template',
    subtitle: 'Define a reusable fee structure',
    backToList: 'Back to Fee Templates',
    infoMessage: 'Create a fee template to define reusable pricing structures that can be applied to multiple schedules.',
    basicInfo: 'Basic Information',
    nameHelper: 'Descriptive name for this template',
    currencyHelper: 'Currency for all fees in this template',
    descriptionHelper: 'Optional description of this template',
    feeStructure: 'Fee Structure',
  },
  edit: {
    title: 'Edit %{name}',
    subtitle: 'Modify fee template configuration',
    backToList: 'Back to Fee Templates',
    basicInfo: 'Basic Information',
    feeStructure: 'Fee Structure',
    statusInfo: 'Status Information',
    usageWarning: 'This template is used by %{count} fee schedule(s). Changes will affect all schedules using this template.',
    nameHelper: 'Descriptive name for this template',
    currencyHelper: 'Currency cannot be changed after creation',
    descriptionHelper: 'Optional description of this template',
  },
  show: {
    title: 'Fee Template Details',
    subtitle: 'View template configuration and usage',
    backToList: 'Back to Fee Templates',
    basicInfo: 'Basic Information',
    feeStructure: 'Fee Structure',
    usage: 'Usage Information',
    noSchedules: 'This template is not currently used by any schedules.',
    schedulesUsing: 'Schedules Using This Template',
    metadata: 'Metadata',
    scheduledChanges: 'Scheduled Changes',
    scheduledChangesInfo: 'Changes scheduled to take effect at a future date',
  },
  list: {
    title: 'Fee Templates',
    filters: {
      search: 'Search by name',
      currency: 'Currency',
      activeOnly: 'Active Only',
      isSystem: 'Template Type',
      systemTemplates: 'System Templates',
      customTemplates: 'Custom Templates',
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
    },
  },
  notifications: {
    created: 'Fee template created successfully',
    updated: 'Fee template updated successfully',
    deleted: 'Fee template deleted successfully',
    changeScheduled: 'Fee template change scheduled successfully',
    scheduleFailed: 'Failed to schedule fee template change',
  },
  validation: {
    effectiveDateRequired: 'Effective date is required',
    idleFeeRatePositive: 'Rate must be greater than 0 when idle fees are enabled',
    idleFeeGraceMinutesInteger: 'Grace minutes must be a non-negative integer when idle fees are enabled',
    sessionFeeAmountNonNegative: 'Session fee amount must be 0 or greater when enabled.',
    timeFeeUnitRequired: 'Select a time unit (minute or hour).',
    timeFeeRatesRequired: 'Add at least one time rate when time fee is enabled.',
    timeFeeRatePositive: 'Each time rate must be greater than 0.',
    timeFeeFreeMinutesInteger: 'Free minutes must be a non-negative integer.',
    timeFeeMaxChargeMinutesNonNegative: 'Max charging time must be 0 or greater.',
    timeFeePreAuthNonNegative: 'Pre-auth amount must be 0 or greater.',
    energyTimeMutuallyExclusive: 'Energy and Time fees cannot both be enabled. Choose one consumption fee.',
  },
  schedule: {
    title: 'Schedule Fee Template Change',
    info: 'Schedule changes to this fee template to take effect at a future date',
    effectiveDate: 'Effective Date',
    effectiveDateHelper: 'When these changes will take effect',
    reason: 'Reason for Change',
    reasonHelper: 'Optional reason for this change',
    warning: 'Scheduled changes will automatically apply at the specified time',
  },
  tooltips: {
    sessionFee: 'A fixed fee charged at the start of each charging session',
    energyFee: 'Fee based on the amount of energy consumed (kWh)',
    timeFee: 'Fee based on the duration of the charging session',
    idleFee: 'Fee charged when the vehicle remains connected after charging is complete',
    idleFeeEnabledDisabled: 'When disabled, users will not see a grace period screen after charging completes, and no idle fees will be charged. Set graceMinutes=0 with enabled to charge fees immediately on completion.',
    reservationFee: 'Fee for reserving a charging slot in advance',
  },
  actions: {
    addRate: 'Add Rate',
    removeRate: 'Remove Rate',
    addTimeRange: 'Add Time Range',
    removeTimeRange: 'Remove Time Range',
    saveNow: 'Save Now',
    scheduleChange: 'Schedule Change',
    confirmSchedule: 'Schedule Change',
  },
  sessionFee: {
    amountHelper: 'Fixed amount charged per session',
  },
  energyFee: {
    nameHelper: 'Name for this rate (e.g., Peak, Off-Peak)',
    rateHelper: 'Price per kWh of energy consumed',
    timeRange: 'Time Range',
    appliesAllTime: 'Applies all time',
    allTimeHelper: 'This rate applies 24/7',
    startTime: 'Start Time',
    endTime: 'End Time',
    timeRangeHelper: 'Time range when this rate applies',
    addTimeRange: 'Add Time Range',
    explanation: 'Define different rates for different time periods',
  },
  timeFee: {
    rateHelper: 'Amount charged per minute of charging',
    maxChargeMinutesHelper: 'Auto-stops the session at this many charging minutes (0 = no limit).',
    preAuthHelper: 'Pre-auth hold for unlimited time sessions (0 = no hold).',
  },
  idleFee: {
    rateHelper: 'Amount charged per minute after grace period expires',
  },
  reservationFee: {
    enableHelper: 'When enabled, users can reserve this charger. When disabled, reservation is not allowed.',
    amountHelper: 'Amount held from wallet at booking. Set to 0 to allow reservations with no fee.',
    zeroAmountNote: 'Amount is 0 — reservations will be allowed with no wallet hold. Policy rules (cancel window, etc.) still apply.',
    policy: 'Reservation Policy',
    policyHelper: 'Choose a policy preset that defines reservation rules (timing, mode, fee behavior). Leave on "System Default" to use the default preset.',
    useSystemDefault: 'System Default',
    default: 'Default',
    refundBehavior: 'Refund Behavior',
  },
  status: {
    pending: 'Pending',
    applied: 'Applied',
    cancelled: 'Cancelled',
    failed: 'Failed',
  },
};